/* PEEK SLIDER — Affordance de slider en mobile
 * Mobile only. Hace un "peek" en la primera tarjeta con slider:
 * va a la 2da imagen y regresa, para indicar que se puede deslizar.
 *
 *  - Sección carrusel (New In): cada vez que la sección entra en viewport.
 *  - Collection page: una sola vez, cuando el primer producto está claramente
 *    en pantalla. Si la 1ra tarjeta no tiene imagen secundaria, intenta la 2da.
 *
 * Dots: ocultos por defecto. Se muestran durante el peek automático
 * (clase .is-peeking) y mientras el usuario desliza (clase .is-sliding),
 * en cualquier tarjeta con slider de la página.
 *
 * Respeta prefers-reduced-motion y la interacción del usuario.
 */
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  // --- Config compartida del peek ---
  var PEEK_HOLD_MS = 700;       // tiempo en la 2da imagen antes de regresar
  var PEEK_DOTS_LINGER_MS = 500; // dots siguen visibles tras regresar a la 1ra imagen
  var SLICK_RETRY_MS = 150;     // reintento si Slick aún no inicializó
  var SLICK_MAX_RETRIES = 12;

  // --- Config sección ---
  var VISIBILITY_THRESHOLD = 0.5; // 50% visible
  var COOLDOWN_MS = 1500;         // evita re-disparos por micro-scrolls

  // --- Config collection ---
  var COLLECTION_THRESHOLD = 0.6;    // primer producto "claramente" en pantalla
  var COLLECTION_MAX_CANDIDATES = 2; // intenta 1ra y, si no, 2da tarjeta

  // --- Config dots (interacción manual) ---
  var SLIDING_HIDE_MS = 1000; // ocultar dots ~1s tras dejar de deslizar

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  // ¿El slider de esta tarjeta tiene 2+ imágenes? (mismo criterio que initMobileCardSliders)
  function sliderHasSecondary(slider) {
    if (!slider) return false;
    return slider.querySelectorAll('.card-mobile-slide:not(.is-hidden)').length >= 2;
  }

  // ----------------------------------------------------------------
  // PEEK (lógica compartida)
  // ----------------------------------------------------------------
  function doPeek(slider, retries) {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;
    var $slider = jQuery(slider);

    // Si el usuario ya interactuó con esta tarjeta, no molestamos.
    if (slider.dataset.peekUserTouched === 'true') return;

    if (!$slider.hasClass('slick-initialized')) {
      // Slick puede no haberse inicializado todavía: reintentamos.
      if ((retries || 0) < SLICK_MAX_RETRIES) {
        setTimeout(function () { doPeek(slider, (retries || 0) + 1); }, SLICK_RETRY_MS);
      }
      return;
    }

    // Sólo tiene sentido si hay más de una slide.
    var slideCount = slider.querySelectorAll('.card-mobile-slide:not(.is-hidden)').length;
    if (slideCount < 2) return;

    // Mostrar dots durante el peek.
    slider.classList.add('is-peeking');

    $slider.slick('slickGoTo', 1);

    setTimeout(function () {
      // Si el usuario tocó durante el peek, que mande lo manual:
      // soltamos is-peeking y dejamos que is-sliding controle los dots.
      if (slider.dataset.peekUserTouched === 'true') {
        slider.classList.remove('is-peeking');
        return;
      }

      // Regreso a la primera imagen.
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('slickGoTo', 0);
      }

      // Mantener los dots un poco más para que se vea el regreso completo,
      // y recién ahí ocultarlos (salvo que el usuario empiece a deslizar).
      setTimeout(function () {
        if (slider.dataset.peekUserTouched === 'true') return; // lo maneja is-sliding
        slider.classList.remove('is-peeking');
      }, PEEK_DOTS_LINGER_MS);

    }, PEEK_HOLD_MS);
  }

  // Marca la tarjeta como "tocada" para no pisar el gesto del usuario.
  function bindUserTouch(slider) {
    if (slider.dataset.peekTouchBound === 'true') return;
    slider.dataset.peekTouchBound = 'true';
    ['touchstart', 'pointerdown', 'mousedown'].forEach(function (evt) {
      slider.addEventListener(evt, function () {
        slider.dataset.peekUserTouched = 'true';
      }, { passive: true });
    });
  }

  // Dispara el peek de forma segura sobre un slider concreto.
  function triggerPeek(slider) {
    if (!slider) return;
    if (!isMobile() || prefersReducedMotion()) return;
    bindUserTouch(slider);
    doPeek(slider, 0);
  }

  // ----------------------------------------------------------------
  // DOTS AL DESLIZAR MANUALMENTE (delegado, todas las tarjetas)
  // ----------------------------------------------------------------
  function showSlidingDots(slider) {
    if (!slider) return;
    slider.classList.add('is-sliding');

    // Reinicia el temporizador de ocultar con cada interacción.
    if (slider._slidingTimer) clearTimeout(slider._slidingTimer);
    slider._slidingTimer = setTimeout(function () {
      slider.classList.remove('is-sliding');
      slider._slidingTimer = null;
    }, SLIDING_HIDE_MS);
  }

  function setupSlidingDots() {
    // Detecta interacción de toque/puntero sobre cualquier slider de la página.
    ['touchstart', 'pointerdown'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var slider = e.target.closest && e.target.closest('[data-card-mobile-slider]');
        if (!slider) return;
        if (!isMobile()) return;
        showSlidingDots(slider);
      }, { passive: true });
    });

    // Mientras el usuario arrastra, mantener visibles (reinicia el timer).
    document.addEventListener('touchmove', function (e) {
      var slider = e.target.closest && e.target.closest('[data-card-mobile-slider]');
      if (!slider) return;
      if (!isMobile()) return;
      showSlidingDots(slider);
    }, { passive: true });
  }

  // ----------------------------------------------------------------
  // SECCIÓN CARRUSEL (New In) — IntersectionObserver, cada entrada
  // ----------------------------------------------------------------
  function firstSliderIn(container) {
    return container.querySelector('.newin__item [data-card-mobile-slider]')
        || container.querySelector('[data-card-mobile-slider]');
  }

  function setupSection(section) {
    if (section.dataset.peekObserved === 'true') return;
    section.dataset.peekObserved = 'true';

    var lastFired = 0;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (!isMobile() || prefersReducedMotion()) return;

        var now = Date.now();
        if (now - lastFired < COOLDOWN_MS) return; // cooldown
        lastFired = now;

        triggerPeek(firstSliderIn(section));
      });
    }, { threshold: VISIBILITY_THRESHOLD });

    observer.observe(section);
  }

  function initSections() {
    document.querySelectorAll('[id^="new-in-"]').forEach(setupSection);
  }

  // ----------------------------------------------------------------
  // COLLECTION PAGE — una sola vez, cuando el primer producto
  // está claramente en pantalla. Si la 1ra tarjeta no tiene imagen
  // secundaria, intenta la 2da; si tampoco, descarta el peek.
  // ----------------------------------------------------------------
  function pickCollectionSlider(grid) {
    var items = grid.querySelectorAll('.grid__item');
    var limit = Math.min(items.length, COLLECTION_MAX_CANDIDATES);
    for (var i = 0; i < limit; i++) {
      var slider = items[i].querySelector('[data-card-mobile-slider]');
      if (sliderHasSecondary(slider)) return slider;
    }
    return null; // ninguna de las candidatas tiene imagen secundaria
  }

  function initCollection() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    if (grid.dataset.peekObserved === 'true') return;
    grid.dataset.peekObserved = 'true';

    var firstItem = grid.querySelector('.grid__item');
    if (!firstItem) return;

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        // Disparo único: desconectamos en cuanto el gatillo se cumple.
        obs.disconnect();

        if (!isMobile() || prefersReducedMotion()) return;

        triggerPeek(pickCollectionSlider(grid));
      });
    }, { threshold: COLLECTION_THRESHOLD });

    observer.observe(firstItem);
  }

  // ----------------------------------------------------------------
  // INIT
  // ----------------------------------------------------------------
  function init() {
    setupSlidingDots();
    initSections();
    initCollection();
  }

  document.addEventListener('DOMContentLoaded', init);
  // Soporte editor de Shopify (al recargar una sección).
  document.addEventListener('shopify:section:load', initSections);
})();